module.exports = __webpack_public_path__ + "img/logo-red.0720903.svg";